module.exports = Loca;